<div style="max-height: 7rem;">
<router-outlet></router-outlet>
</div>
